import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import { useAppUpdate } from '../hooks/useAppUpdate';

// Aviso discreto de nova versão. Fica acima da barra inferior mobile e da safe-area.
export default function AppUpdateBanner() {
  const { updateAvailable, applyUpdate } = useAppUpdate();
  const [busy, setBusy] = useState(false);

  const handleUpdate = async () => {
    setBusy(true);
    await applyUpdate();
  };

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message="Nova versão disponível"
      action={
        <Button color="inherit" size="small" disabled={busy} onClick={handleUpdate} sx={{ fontWeight: 700 }}>
          Atualizar
        </Button>
      }
      sx={{
        bottom: {
          xs: 'calc(96px + env(safe-area-inset-bottom, 0px)) !important',
          md: 'calc(24px + env(safe-area-inset-bottom, 0px)) !important',
        },
      }}
    />
  );
}
